// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3cTL2","name":"ConsentHeader_name__1xh94","birthday":"ConsentHeader_birthday__2G2pm","skeleton":"ConsentHeader_skeleton__L6MvF"};